import styled from "styled-components";

const Card = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.gray100};
  border-radius: 3px;
  margin-bottom: 1rem;
  padding: 1rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export default Card;
